import { DelegatedObservableArrayChangeListenner, ObservableArray, View } from "binder"
import { HomePageViewModel, singleItem } from "./homePage-viewModel"
import { stringIsNullOrEmpty } from "../utilities";
declare var GridStack;
export class HomePageView extends View<HomePageViewModel>{
    GetViewUniqueId(): string {
        return "V-73491713-9217-4D8D-B8DF-3A7299730944"
    }
    loadHtml(): string {
        let element = require('./homePage.html').default;
        let style = require('./homePage.less');
        return element;
    }
    constructor() {
        super();
        let realThis = this;
        let trySave = this.trySave.bind(this);
        GridStack.renderCB = function(el, w) {
            el.onclick = (e:PointerEvent)=>{
                if((<HTMLElement>e.target).classList.contains("edit-settings")){
                    let colorPicker : HTMLInputElement = (<HTMLElement>e.target).parentElement.querySelector('input.edit-settings');
                    if((<any>colorPicker).onChangeIsSet!==true){
                        (<any>colorPicker).onChangeIsSet = true;
                        colorPicker.onchange = (e)=>{
                            w.backgroundColor = colorPicker.value;
                            realThis.dataContext.backgroundColors.set(w.id,colorPicker.value);
                            (<HTMLDivElement>(<HTMLElement>el).querySelector('.card2')).style.background = colorPicker.value;
                            trySave();
                        }
                    }
                    colorPicker.click();
                }else{
                    (<any>window).openHomePageTile(w.id)
                }
            };
           
            el.innerHTML = w.content;
            el.classList.add('no-div-height')
        };
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set tileChangelistenner(v: DelegatedObservableArrayChangeListenner) { this._tileChangelistenner = v; } public get tileChangelistenner(): DelegatedObservableArrayChangeListenner { return this._tileChangelistenner;} private _tileChangelistenner: DelegatedObservableArrayChangeListenner;
    public set self(v: HomePageViewModel) { this._self = v; } public get self(): HomePageViewModel { return this._self;} private _self: HomePageViewModel;
    public set tiles(v: ObservableArray<singleItem>) { 
        if(this.tiles){
            this.tiles.removeChangeListenner(this.tileChangelistenner);
        }
        this._tiles = v; 
        if(this.tiles){
            this.tileChangelistenner = new DelegatedObservableArrayChangeListenner(this,()=>this.redrawTiles());
            this.tiles.addChangeListenner(this.tileChangelistenner);
        }
    } public get tiles(): ObservableArray<singleItem> { return this._tiles;} private _tiles: ObservableArray<singleItem>;
    private containerDiv : HTMLDivElement;
    private gridStackContainer :any;
    public onRenderCompleted() {
        this.containerDiv = this.firstlevelElement.querySelector('#V-73491713-9217-4D8D-B8DF-3A7299730944-container');
        this.gridStackContainer = GridStack.init({
            cellHeight : 'auto',
            cellHeightThrottle: 100,
            column : 12,
            row : 10,
            rtl : false,
            alwaysShowResizeHandle : true,
            animate : true,
            class : 'no-div-height',
            itemClass : 'no-div-height',
            float: true,

        },this.containerDiv);
        this.gridStackContainer.on("added",()=>this.trySave());
        this.gridStackContainer.on("removed",()=>this.trySave());
        this.gridStackContainer.on("dragstop",()=>this.trySave());
        this.gridStackContainer.on("dropped",()=>this.trySave());
        this.gridStackContainer.on("resizestop",()=>this.trySave());
    }
    private trySave(){
        let saveResult = <any[]>this.gridStackContainer.save();
        this.dataContext.saveChanges(saveResult.map(x=>{
            let info : any = {
                x: x.x,
                y: x.y,
                w: x.w,
                h: x.h,
                id: x.id,
            };
            if(x.backgroundColor){
                info.backgroundColor = x.backgroundColor;
                this.dataContext.backgroundColors.set(x.id,x.backgroundColor);
            }
            return info;
        }));
        
    }

    updateHOmePageStructure(){

    }
    public onDataContextSet() {
        this.dataContext.tryRedraw = this.redraw.bind(this);
    }
    private redrawTiles(){
        if(this.containerDiv && this.tiles && this.gridStackContainer){
            this.gridStackContainer.load(
                this.tiles.map(x=>{
                    const backgroundColor = this.dataContext.backgroundColors.has(x.id) ? this.dataContext.backgroundColors.get(x.id) : undefined;
                    return{
                        content : `<div class="card2" ${backgroundColor==undefined ? "" : `style="background:${x.backgroundColor}`}">
                        <input type="color" style="border:none;border: none;visibility: hidden;height: 0px;width: 0px;position: absolute;inset-inline-start: 0;inset-block-start: 0;" class="edit-settings">
                        <i class="bi edit edit-settings" style="
                            position: absolute;
                            inset-inline-start: 1rem;
                            inset-block-start: 1rem;
                        "></i>    
                        <div>
                            ${stringIsNullOrEmpty(x.iconClass) ? '' : `<img class="V-65ECE636-0C4B-4FCF-AC3E-36A108345B2B-icon-place" style="width: 25%;object-fit: contain;float: inline-end;height: 100%;inset-inline-end: 1ch;inset-block-start: 1ch;" src="/res/MenuIcons/${x.iconClass}" />`}
                            <h5 style="${stringIsNullOrEmpty(x.iconClass) ? 'width: 100%' : 'width: 75%'};float: inline-start;height: 100%;align-content: center;">${x.name}</h5>
                        </div>
                        </div>`,
                        id : x.id,
                        autoPosition : false,
                        noResize : false,
                        noMove : false,
                        sizeToContent : false,
                        w : x.width ?? 3,
                        h : x.height,
                        x : x.x,
                        y : x.y,
                        backgroundColor : x.backgroundColor

                    }
                })
            );
            
        }
    }
    redraw(){
        if(this.gridStackContainer){
            this.gridStackContainer.destroy(false);
            this.onRenderCompleted();
        }
    }
}
